// Register the service worker so the app is installable as a PWA and can
// support background sync / notifications / offline (TBD) later.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch(err => console.warn("SW registration failed:", err))
  })
}
